module.exports = __webpack_public_path__ + "static/media/xiuMiIcon.973e6c8c.png";